import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { ProjectResponse } from '../../lib'

const get = async () => {
  return await api.json<ProjectResponse[]>(API_END_POINTS.project.getProjects)
}

export default get
